import styled, { css } from 'styled-components'

const SelectField = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.75)};
  `}
`

const Select = styled.select`
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacing(2)} ${theme.spacing(5)} ${theme.spacing(2)} ${theme.spacing(2)};
    font-size: 1.8rem;
    border: 0.1rem solid ${theme.palette.grey[500]};
    background-color: white;
    appearance: initial;
    border-radius: 0;
    text-overflow: ellipsis;

    &.hasError {
      border-color: #da2f47;
    }

    &:hover {
      border-color: ${theme.palette.grey[900]};
    }

    &:focus {
      outline: 0.2rem solid #000;
      border-color: transparent;
    }
  `}
`

const Wrapper = styled.div`
  ${({ theme }) => css`
    position: relative;

    svg {
      position: absolute;
      right: ${theme.spacing(2)};
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  `}
`

export default {
  SelectField,
  Select,
  Wrapper,
}
